import { IConfig, InstitutionType } from '@alberta/konexi-shared';
import { IInstitutionAttributeConfig } from '@alberta/konexi-shared/dist/general/config/institution-attribute-config';
import { Injectable } from '@angular/core';
import { TenantConfigService } from 'src/app/shared/services/tenant-config/tenant-config.service';

@Injectable()
export class InstitutionAttributeConfigService {
  constructor(private _tenantConfigService: TenantConfigService) {
    this.loadingComplete = this.getInstitutionAttributes();
  }

  private config: IConfig;
  private institutionAttributes: IInstitutionAttributeConfig[];
  private loadingComplete: Promise<void>;

  public async getAttributesForInstitutionType(
    institutionType: InstitutionType
  ): Promise<IInstitutionAttributeConfig[]> {
    await this.loadingComplete;
    if (this.institutionAttributes) {
      return this.institutionAttributes.filter(attribute => attribute.institutionTypes.includes(institutionType));
    }
    return [];
  }

  private getInstitutionAttributes() {
    return new Promise<void>(async resolve => {
      this.config = await this._tenantConfigService.getTenantConfig();
      this.institutionAttributes = this.config.institutionAttributeConfig;
      resolve();
    });
  }
}
